import { ValidationError, ValidationErrors } from "src/errors";
import { FormDataKey } from "src/types";

export class FormValidator {
  protected static validateFormData<T extends FormDataKey>(
    formData: Partial<Record<T, unknown>>,
    validationStrategies: Record<T, (inputValue: unknown) => ValidationError<T> | undefined>
  ): ValidationErrors<T> {
    const errors = new ValidationErrors<T>();

    for (const field of Object.keys(formData) as T[]) {
      const inputValue = formData[field];

      const validationStrategy = validationStrategies[field];

      if (!validationStrategy) {
        throw new Error(`No validation strategy found for field: ${field}`);
      }

      const validationError = validationStrategy(inputValue);

      if (validationError) {
        errors.push(validationError);
      }
    }

    return errors;
  }
}
